import { Component } from 'js-component-framework';
import Throttle from '../../utilities/Throttle';

/**
 * Component that makes iframe element's height dynamic based on content.
 * Requires iframe source to share the same domain (prb.org)
 */
export default class DynamicIframe extends Component {
  /**
   * Instantiate component.
   * @param  {object} config Configuration object. @see index
   * @return {void}
   */
  constructor(config) {
    super(config);

    // On init
    this.updateHeight();

    // On frame load
    this.element.onload = () => {
      this.updateHeight();
    };

    // On resize
    this.throttle = new Throttle(
      this.updateHeight.bind(this),
      'resize',
      window,
      1000
    );

    // On application finishing loading
    window.addEventListener('message', (e) => {
      if (e.data.updated) {
        this.updateHeight();
      }
    }, false);
  }

  /**
   * Given an element, update the height of the element based on the height
   * of its inner frame.`
   * @return {void}
   */
  updateHeight() {
    try {
      // Pin vars for easy use
      const contentWindow = this.element.contentWindow;
      const documentElement = contentWindow.document.documentElement;
      const documentHeight = documentElement.scrollHeight;
      const bodyHeight = contentWindow.document.body.scrollHeight;

      // The new height should be the greater of the document or body heights
      const innerHeight = documentHeight > bodyHeight ?
        documentHeight :
        bodyHeight;

      // Update parent frame's style
      this.element.style.height = `${innerHeight}px`;
      console.info(`Updated iframe height to ${innerHeight}px`); // eslint-disable-line no-console
    } catch (error) {
      console.warn( // eslint-disable-line no-console
        'Could not update iframe',
        this.element,
        error
      );
    }
  }
}



// WEBPACK FOOTER //
// ./client/js/components/DynamicIframe/DynamicIframe.js